import { Card, CardContent } from "../../UI/card";
// import AboutGame from './AboutGame'
import { useMemo, useState } from "react";

/**
 * HoverTooltip - Component for displaying image tooltip on hover
 */
const HoverTooltip = ({ children, imageUrl, highlightText }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (e) => {
    setIsHovered(true);
    const rect = e.target.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <span
        className="bg-yellow-100 px-1 rounded cursor-pointer hover:bg-yellow-200 transition-colors duration-200"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {highlightText}
      </span>
      {isHovered && (
        <div
          className="fixed z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-2"
          style={{
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
            transform: 'translate(-50%, -100%)',
            maxWidth: '300px'
          }}
        >
          <img
            src={imageUrl}
            alt="Game screenshot"
            className="w-full h-auto rounded"
            style={{ maxHeight: '200px', objectFit: 'contain' }}
          />
        </div>
      )}
      {children}
    </>
  );
};

/**
 * Utility function to replace game references with HoverTooltip components
 */
const processGameReferences = (text) => {
  // Define the replacements
  const replacements = [
    {
      pattern: /In Slide/g,
      component: (
        <HoverTooltip
          imageUrl="https://fe-staging.censioanalytics.com/static/media/circuit_Boards.cdf998543c0efdb7f463.png"
          highlightText="In Circuit Board"
        />
      )
    },
    {
      pattern: /In Stack/g,
      component: (
        <HoverTooltip
          imageUrl="https://fe-staging.censioanalytics.com/static/media/assembly_line.f0c5cb3b89e6f410f4f6.png"
          highlightText="In Assembly Line"
        />
      )
    },
    {
      pattern: /In Match/g,
      component: (
        <HoverTooltip
          imageUrl="https://fe-staging.censioanalytics.com/static/media/great-escape-2-0.72dd380a5fa3a3e3d841.png"
          highlightText="In the Parts Shop game"
        />
      )
    }
  ];

  // Split text and process each part
  let parts = [text];

  replacements.forEach((replacement, replacementIndex) => {
    const newParts = [];

    parts.forEach((part, partIndex) => {
      if (typeof part === 'string') {
        const splitParts = part.split(replacement.pattern);

        for (let i = 0; i < splitParts.length; i++) {
          if (i > 0) {
            // Add the replacement component with a unique key
            newParts.push(
              <span key={`replacement-${replacementIndex}-${partIndex}-${i}`}>
                {replacement.component}
              </span>
            );
          }
          if (splitParts[i]) {
            newParts.push(splitParts[i]);
          }
        }
      } else {
        newParts.push(part);
      }
    });

    parts = newParts;
  });

  return parts;
};

const ImagineThisSection = ({ scenarios = [], activeTab, currentConstruct }) => {

  const filteredScenarios = useMemo(() => {
    // For DivergentThinking, show scenarios without game property
    if (currentConstruct === 'divergent thinking') {
      return scenarios.filter(scenario => !scenario.game);
    }

    // For other constructs, filter by activeTab/game
    if (!activeTab) return [];

    const gameType = activeTab.toLowerCase();

    return scenarios.filter(scenario => scenario.game === gameType);
  }, [scenarios, activeTab, currentConstruct]);


  if (filteredScenarios.length === 0) return null;

  return (
    filteredScenarios.map(({ title, details }) => {
      return (
        <Card className={`card border-blue-200 bg-[#1B75BC0F] py-4 text-gray-800`}>
          <CardContent key={title} className='flex flex-col gap-3'>
            <div className="">
              <h3 className="text-2xl font-semibold leading-none tracking-tight text-[#1B75BC]">{title}</h3>
            </div>

            <div className='flex flex-col gap-1'>
              {details.map((paragraph, index) => (
                <span key={index} className="text-xl">
                  {processGameReferences(paragraph)}
                </span>
              ))}
            </div>
          </CardContent>
        </Card>

      );
    })
  );
};

export default ImagineThisSection;
